// ModernSlaveryStatementPage.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";

import ModernSlavery2024 from "./ModernSlavery2024";
import ModernSlavery2023 from "./ModernSlavery2023";
import ModernSlavery2022 from "./ModernSlavery2022";
import ModernSlavery2021 from "./ModernSlavery2021";

const pageMap = {
  2024: ModernSlavery2024,
  2023: ModernSlavery2023,
  2022: ModernSlavery2022,
  2021: ModernSlavery2021,
};

export default function ModernSlaveryStatementPage() {
  const { year } = useParams();
  const Page = pageMap[year];

  if (!Page) {
    return (
      <div className="max-w-4xl mx-auto py-20 text-center">
        <h2 className="text-2xl font-bold mb-4">Statement not found</h2>
        <Link
          to="/policies/modern-slavery-statement"
          className="underline text-primary"
        >
          ← Back to list
        </Link>
      </div>
    );
  }

  return <Page />;
}
